export const any = (...conditions) => (...conditionArguments) => conditions
  .some(condition => condition(...conditionArguments))

export const loggedIn = () => ({ store }) => store.getters.isAuth

export const hasRole = (...roles) => ({ store }) => store.getters.hasRole(...roles)
